import { ExtensionTag, NodeExtension } from 'remirror';

class VideoExtension extends NodeExtension {
  get name() {
    return 'video';
  }

  createTags() {
    return [ExtensionTag.Block, ExtensionTag.Media];
  }

  createNodeSpec(extra) {
    return {
      inline: false,
      group: 'block',
      draggable: true,
      selectable: false,

      attrs: {
        ...extra.defaults(),
        src: '',
        title: '',
        poster: '', // Example: add more attributes as needed
      },

      parseDOM: [
        {
          tag: 'video',
          getAttrs: (dom) => ({
            src: dom.getAttribute('src') || '',
            title: dom.getAttribute('title') || '',
            poster: dom.getAttribute('poster') || '',
            width: dom.getAttribute('width') || '',
          }),
        },
      ],

      toDOM: (node) => {
        return [
          'video',
          {
            src: node.attrs.src,
            title: node.attrs.title,
            poster: node.attrs?.poster,
            width: '700px',
            controls: true,
          },
          0,
        ];
      },
    };
  }

  createCommands() {
    return {
      uploadVideo: (promiseCreator) => {
        return async ({ tr, dispatch }) => {
          const attrs = await promiseCreator();

          const { selection } = tr;
          const node = this.type.create({ ...attrs, poster: '' });
          if (dispatch) dispatch(tr.replaceRangeWith(selection.from, selection.to, node));
          return true;
        };
      },
    };
  }
}

export default VideoExtension;
